import { RESET_STORE, STORE } from '../global';
import { checkWhitelist } from '../reducer-utils';
import {
  PURCHASE_POLICY_FAILED,
  PURCHASE_POLICY_START,
  PURCHASE_POLICY_SUCCESS,
  PolicyCreateStore,
  PolicyCreateAction,
  RESET_POLICY_CREATE,
  SWITCH_ORG_START,
  SWITCH_ORG_FAILED
} from './types';

const initialState = { createPending: true, loading: false };

export const policyCreate = (
  state: PolicyCreateStore = {
    createPending: true,
    loading: false
  },
  action: PolicyCreateAction
): PolicyCreateStore => {
  switch (action.type) {
    case PURCHASE_POLICY_START:
    case SWITCH_ORG_START:
      return { createPending: true, loading: true };
    case PURCHASE_POLICY_SUCCESS: {
      return {
        createPending: false,
        loading: false,
        response: action.payload,
        ...(action.additionalData ? { additionalData: action.additionalData } : {}),
        ...(action.isQuoteSave ? { isQuoteSave: true } : {})
      };
    }
    case PURCHASE_POLICY_FAILED:{
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case SWITCH_ORG_FAILED: {
      return {
        createPending: true,
        loading: false,
        error: action.payload
      };
    }
    case RESET_POLICY_CREATE:
      return initialState;
    case RESET_STORE:
      return checkWhitelist(action.payload.whitelist, STORE.POLICY_CREATE, state, initialState);
    default:
      return state;
  }
};
